import React from "react";
import { MessageCircle } from "lucide-react";

/**
 * Relatório de disparos — em construção.
 *
 * A aba só passa a ter dados quando a integração com a API oficial do WhatsApp
 * (Meta Tech Provider) estiver ativa: é de lá que vem o custo por mensagem,
 * a categoria (lembrete / promoção / conversa) e o status de entrega.
 */
export function DispatchReport() {
  return (
    <div className="mt-5 flex w-full flex-col items-center justify-center gap-3 rounded border border-zinc-200/60 bg-white py-20 text-center">
      <MessageCircle className="h-10 w-10 text-scale-300" aria-hidden="true" />

      <h2 className="m-0 text-lg font-semibold text-scale-600">Relatório de disparos</h2>

      <p className="m-0 max-w-md text-sm text-gray-600">
        Em breve. Aqui você vai acompanhar quanto cada envio custou, separado por
        lembrete, promoção e conversa, com o status de entrega de cada mensagem.
      </p>

      <p className="m-0 text-xs text-gray-400">
        Disponível assim que o WhatsApp oficial da sua loja estiver conectado.
      </p>
    </div>
  );
}
